export default {"src":"/_next/static/media/highstreet.e8060cc0.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};